<template>
  <div class="warn_set_form">
    <!--总开关-->
    <el-form label-width="150px">
      <el-form-item :label="$t('warningSet.AlarmSwitch')">
        <div>
          <el-switch v-model="switchStatus.warningOpenStatus" 
          class="fl in_item" 
          :active-text="$t('BondOrUpdateDevice.On')" 
          :inactive-text="$t('BondOrUpdateDevice.Off')" 
          style="padding: 18px 0; margin-left: 120px" />
        </div>
      </el-form-item>

      <!--SOC-->
      <el-form-item v-if="switchStatus.warningOpenStatus" :label="$t('warningSet.socWarn')">
        <div>
          <el-switch v-model="switchStatus.socSwitchStatus" class="fl in_item" :active-text="$t('BondOrUpdateDevice.On')" :inactive-text="$t('BondOrUpdateDevice.Off')" style="padding: 18px 0; margin-left: 120px" />
          <template v-if="switchStatus.socSwitchStatus">
            <div class="fl in_item">
              <span class="label">{{ $t("warningSet.lowVal") }} ：</span>
              <el-input v-model="form.minSoc" type="number" style="width: 120px; margin-right: 10px" @blur="inputBlur($event, 'minSoc')" />%
            </div>
            <div class="fl in_item">
              <span class="label">{{ $t("warningSet.recoverVal") }}：</span>
              <el-input v-model="form.maxSoc" type="number" style="width: 120px; margin-right: 10px" @blur="inputBlur($event, 'maxSoc')" />%
            </div>
          </template>
        </div>
      </el-form-item>

      <!--温度-->
      <el-form-item v-if="switchStatus.warningOpenStatus" :label="$t('warningSet.temWarn')">
        <div>
          <el-switch v-model="switchStatus.tempSwitchStatus" class="fl in_item" :active-text="$t('BondOrUpdateDevice.On')" :inactive-text="$t('BondOrUpdateDevice.Off')" style="padding: 18px 0; margin-left: 120px" />
          <template v-if="switchStatus.tempSwitchStatus">
            <div class="fl in_item">
              <span class="label">{{ $t("warningSet.lowTemperature") }}：</span>
              <el-input v-model="form.minTemp" type="number" style="width: 120px; margin-right: 10px" @blur="inputBlur($event, 'minTemp')" />
              {{ temType }}
            </div>
            <div class="fl in_item">
              <span class="label">{{ $t("warningSet.HighTemperature") }}：</span>
              <el-input v-model="form.maxTemp" type="number" style="width: 120px; margin-right: 10px" @blur="inputBlur($event, 'maxTemp')" />
              {{ temType }}
            </div>
            <div class="fl in_item">
              <span class="label">{{ $t("warningSet.HighTemperature2") }}：</span>
              <el-input v-model="form.maxTemp2" type="number" style="width: 120px; margin-right: 10px" @blur="inputBlur($event, 'maxTemp2')" />
              {{ temType }}
            </div>
            <div class="fl in_item">
              <span class="label">{{ $t("warningSet.HighTemperature3") }}：</span>
              <el-input v-model="form.maxTemp3" type="number" style="width: 120px; margin-right: 10px" @blur="inputBlur($event, 'maxTemp3')" />
              {{ temType }}
            </div>

            <div class="fl in_item">
              <span class="label">{{ $t("warningSet.temError") }} ：</span>
              <el-input v-model="form.errTemp" type="number" style="width: 120px; margin-right: 10px" @blur="inputBlur($event, 'errTemp')" />
              {{ temType }}
            </div>
          </template>
        </div>
      </el-form-item>

      <!--电压-->
      <el-form-item v-if="switchStatus.warningOpenStatus" :label="$t('warningSet.voltage')">
        <div>
          <el-switch v-model="switchStatus.voltageSwitchStatus" class="fl in_item" :active-text="$t('warningSet.voltageSwitchOn')" :inactive-text="$t('warningSet.voltageSwitchOff')" style="padding: 18px 0; margin-left: 120px" />

          <el-switch v-model="switchStatus.volProtectSwitchStatus" class="fl in_item" :active-text="$t('warningSet.volProtectSwitchOn')" :inactive-text="$t('warningSet.volProtectSwitchOff')" style="padding: 18px 0" />

          <div v-if=" switchStatus.voltageSwitchStatus || switchStatus.volProtectSwitchStatus " class="fl in_item">
            {{ $t("warningSet.lowVoltage") }}：
            <el-input v-model="form.minV" style="width: 100px; margin-right: 10px" @blur="inputBlur($event, 'minV')" />V
          </div>
          <div v-if=" switchStatus.voltageSwitchStatus || switchStatus.volProtectSwitchStatus " class="fl in_item">
            {{ $t("warningSet.lowVoltage2") }}：
            <el-input v-model="form.lowVolLevel2" style="width: 100px; margin-right: 10px" @blur="inputBlur($event, 'lowVolLevel2')" />V
          </div>
          <div v-if=" switchStatus.voltageSwitchStatus || switchStatus.volProtectSwitchStatus " class="fl in_item">
            {{ $t("warningSet.lowVoltage3") }}：
            <el-input v-model="form.lowVolLevel3" style="width: 100px; margin-right: 10px" @blur="inputBlur($event, 'lowVolLevel3')" />V
          </div>

          <div v-if=" switchStatus.voltageSwitchStatus || switchStatus.volProtectSwitchStatus " class="fl in_item">
            {{ $t("warningSet.recoveryVoltage") }}：
            <el-input v-model="form.recoveryVoltage" style="width: 100px; margin-right: 10px" @blur="inputBlur($event, 'recoveryVoltage')" />V
          </div>
          <div v-if="switchStatus.voltageSwitchStatus" class="fl in_item">
            <span class="label">{{ $t("warningSet.hightVoltage") }}：</span>
            <el-input v-model="form.maxV" style="width: 120px; margin-right: 10px" @blur="inputBlur($event, 'hightVoltage')" />V
          </div>
          <div v-if=" switchStatus.voltageSwitchStatus || switchStatus.volProtectSwitchStatus " class="fl in_item">
            <span class="label">{{ $t("warningSet.duration") }}</span>
            <el-input
              v-model="form.voltageDuration"
              type="number"
              style="width: 120px; margin-right: 10px"
              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              @blur="inputBlur($event, 'voltageDuration')"
            />
            {{ $t("dataAndTime.Second") }}
          </div>
        </div>
      </el-form-item>

      <!--半电压-->
      <el-form-item v-if="form.supportHalfVol == 1 && switchStatus.warningOpenStatus" :label="$t('warningSet.HalfV')">
        <div>
          <el-switch v-model="switchStatus.halfvChecked" class="fl in_item" :active-text="$t('BondOrUpdateDevice.On')" :inactive-text="$t('BondOrUpdateDevice.Off')" style="padding: 18px 0; margin-left: 120px" />
          <div class="fl in_item">
            <span class="label">{{ $t("warningSet.HalfVThreshold") }}</span>
            <el-input v-model="form.halfVol" type="number" style="width: 120px; margin-right: 10px" @blur="inputBlur($event, 'halfVol')" />mV
          </div>

          <div class="fl in_item">
            <span class="label">{{ $t("warningSet.duration") }}</span>
            <el-input
              v-model="form.halfVoltageDuration"
              type="number"
              style="width: 120px; margin-right: 10px"
              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              @blur="inputBlur($event, 'halfVoltageDuration')"
            />
            {{ $t("dataAndTime.Second") }}
          </div>
        </div>
      </el-form-item>

      <!--液位-->
      <el-form-item v-if="form.supportWaterLevel2 == 1 && switchStatus.warningOpenStatus" :label="$t('warningSet.LevelWarning')">
        <div>
          <el-switch v-model="switchStatus.supportWaterLevelStatus" class="fl in_item" :active-text="$t('BondOrUpdateDevice.On')" :inactive-text="$t('BondOrUpdateDevice.Off')" style="padding: 18px 0; margin-left: 120px" />
          <template v-if="switchStatus.supportWaterLevelStatus">
            <span class="label">{{ $t("warningSet.duration") }}：</span>
            <el-input
              v-model="form.waterDuration"
              type="number"
              style="width: 120px; margin-right: 10px"
              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              @blur="inputBlur($event, 'waterDuration')"
            />
            {{ $t("dataAndTime.Min") }}
          </template>
        </div>
      </el-form-item>

      <!--离线警告-->
      <el-form-item v-if="switchStatus.warningOpenStatus" :label="$t('warningSet.OfflineTime')">
        <div>
          <el-switch v-model="switchStatus.netSwitchStatus" class="fl in_item" :active-text="$t('BondOrUpdateDevice.On')" :inactive-text="$t('BondOrUpdateDevice.Off')" style="padding: 18px 0; margin-left: 120px" />
          <div v-if="switchStatus.netSwitchStatus" class="fl in_item">
            <span class="label">{{ $t("warningSet.OfflineTime2") }}：</span>
            <el-input
              v-model="form.offLine"
              type="number"
              style="width: 120px"
              onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
              @blur="inputBlur($event, 'offLine')"
            />
            {{ $t("dataAndTime.Hour") }}
          </div>
        </div>
      </el-form-item>

      <!--电流-->
      <el-form-item v-if="switchStatus.warningOpenStatus" :label="$t('warningSet.current')">
        <el-switch v-model="switchStatus.chargeCurrentSwitchStatus" class="fl in_item" :active-text="$t('warningSet.chargeCurrentSwitchOn')" :inactive-text="$t('warningSet.chargeCurrentSwitchOff')" style="padding: 18px 0; margin-left: 120px" />

        <el-switch v-model="switchStatus.dischargeCurrentSwitchStatus" class="fl in_item" :active-text="$t('warningSet.dischargeCurrentSwitchOn')" :inactive-text="$t('warningSet.dischargeCurrentSwitchOff')" style="padding: 18px 0; margin-left: 120px" />

        <div v-if="switchStatus.chargeCurrentSwitchStatus" class="fl in_item" style="margin-left: 120px; float: left">
          <span class="label">{{ $t("warningSet.chargingOvercurrent") }}：</span>
          <el-input v-model="form.chargeCurrent" type="number" style="width: 120px" @blur="inputBlur($event, 'chargeCurrent')" />A</div>

        <div v-if="switchStatus.dischargeCurrentSwitchStatus" class="fl in_item">
          <span class="label">{{ $t("warningSet.dischargeOvercurrent") }}：</span>
          <el-input v-model="form.dischargeCurrent" type="number" style="width: 120px" @blur="inputBlur($event, 'dischargeCurrent')" />A</div>

        <div v-if=" switchStatus.dischargeCurrentSwitchStatus || switchStatus.chargeCurrentSwitchStatus " class="fl in_item">
          <span class="label">{{ $t("warningSet.duration") }}</span>
          <el-input
            v-model="form.currentDuration"
            type="number"
            style="width: 120px"
            onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^0-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
            @blur="inputBlur($event, 'currentDuration')"
          />
          {{ $t("dataAndTime.Second") }}
        </div>
      </el-form-item>

      <el-form-item v-if="switchStatus.warningOpenStatus" :label="$t('warningSet.charging_limit')">
        <el-switch v-model="switchStatus.linchongChecked" class="fl in_item" :active-text="$t('BondOrUpdateDevice.On')" :inactive-text="$t('BondOrUpdateDevice.Off')" style="padding: 18px 0; margin-left: 120px" />
        <span class="label">{{ $t("warningSet.times_greater") }}：</span>
        <el-input v-model="form.intermediateChargeTimes" type="number" style="width: 120px" @blur="inputBlur($event, 'chargeCurrent')" />
      </el-form-item>
      <el-form-item v-if="switchStatus.warningOpenStatus" :label="$t('warningSet.chargeDisWarn')">
        <el-switch v-model="switchStatus.chargeDisChecked" class="fl in_item" :active-text="$t('BondOrUpdateDevice.On')" :inactive-text="$t('BondOrUpdateDevice.Off')" style="padding: 18px 0; margin-left: 120px" />
        <span class="label">{{ $t("warningSet.chargeDisWarnVal") }}(%)：</span>
        <el-input v-model="form.chargingDischargingRateValue" type="number" style="width: 120px" @blur="inputBlur($event, 'chargeCurrent')" />
      </el-form-item>

      <el-form-item v-if="switchStatus.warningOpenStatus" :label="$t('warningSet.periodic_vehicles')">
        <el-switch v-model="switchStatus.cheliangChecked" class="fl in_item" :active-text="$t('BondOrUpdateDevice.On')" :inactive-text="$t('BondOrUpdateDevice.Off')" style="padding: 18px 0; margin-left: 120px" />
        <div class="fl in_item" style="margin-left: 120px; float: left">
          <span>{{ $t('warningSet.every_month_1') }} </span>
          <el-select v-model="form.vehicleMaintenanceDay" class="noborder smailSelect">
            <el-option v-for="item in 28" :key="item" :label="item" :value="item" />
          </el-select>
          <span>{{ $t('warningSet.every_month_2') }}</span>
        </div>
      </el-form-item>

      <el-form-item v-if="switchStatus.warningOpenStatus" :label="$t('warningSet.battery_maint')">
        <el-switch v-model="switchStatus.dianchiChecked" class="fl in_item" :active-text="$t('BondOrUpdateDevice.On')" :inactive-text="$t('BondOrUpdateDevice.Off')" style="padding: 18px 0; margin-left: 120px" />
        <div class="fl in_item" style="margin-left: 120px; float: left">
          <span>{{ $t('warningSet.MaintMethod') }}</span>
          <el-select v-model="form.batteryMaintenanceType" class="noborder" style="width:300px;">
            <el-option v-for="item in batteryMainOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </div>
        <div v-if="form.batteryMaintenanceType==1&&switchStatus.warningOpenStatus" class="fl in_item" style="margin-left: 120px; float: left">
          <span>{{ $t('warningSet.every_month_1') }} </span>
          <el-select v-model="dianchiVal1" class="noborder smailSelect">
            <el-option v-for="item in 28" :key="item" :label="item" :value="item" />
          </el-select>
          <span>{{ $t('warningSet.every_month_2') }}</span>
        </div>
        <div v-if="form.batteryMaintenanceType==2&&switchStatus.warningOpenStatus" class="fl in_item" style="margin-left: 120px; float: left">
          <span>{{ $t('warningSet.per_charge_1') }}(AH)</span>
          <el-input v-model="dianchiVal2" type="number" style="width: 120px" @blur="inputBlur($event)" />
        </div>
      </el-form-item>

      <!-- 服务到期邮件通知 -->
      <el-form-item :label="$t('warningSet.seen')">
        <el-switch v-model="form.dataServiceExpireSwitch" 
        class="fl in_item" 
        :active-text="$t('BondOrUpdateDevice.On')" 
        :inactive-text="$t('BondOrUpdateDevice.Off')" 
        :active-value="1"
        :inactive-value="0"
        style="padding: 18px 0; margin-left: 120px" />
      </el-form-item>

      <el-form-item :label="$t('warningSet.subscribe_news')">
        <div class="in_item" style="width:calc(100% - 120px);">
          <el-select v-model="statusSwitches" class="noborder" multiple :placeholder="$t('button.select')">
            <el-option v-for="item in subNewsOptions" :key="item.key" :label="$t(item.label)" :value="item.key" />
          </el-select>
        </div>
      </el-form-item>

      <!--推送人-->
      <el-form-item :label="$t('warningSet.contactList')">
        <div class="in_item selectUser" style="width:calc(100% - 120px);">
          <el-cascader v-model="selectUserId" :placeholder="$t('warningSet.owner')" :show-all-levels="false" :options="users" :props="{ multiple: true,value:'label' }" filterable @change="changeSelectUser" />
        </div>
      </el-form-item>

      <el-button v-if="$store.state.userInfo.guestFlag!=true" type="primary" style="float: right" @click="onSubmit">{{ $t("button.Submit") }}</el-button>
    </el-form>
  </div>
</template>

<script>
import { temChange, temUnit, temHsdToSsd } from '@/utils/temChange.js'
import $ from 'jquery'
import { getwarningSettingByMcuId, updateWarningSetting, updatePushMsgUser, getCompanyUserName, selectByMcuId, getGroupCompanyUserList, saveOrUpdate, getByMcuId, insertYhubWarningSettingLog } from '@/api/warning'
export default {
  props: {
    /* eslint-disable */
    icon: String,
    name: String,
    type: {
      type: String,
      default: "text"
    },
    value: [String, Number],
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    min: String,
    max: String,
    step: String,
    minlength: Number,
    maxlength: Number,
    required: {
      type: Boolean,
      default: true
    },
    autoComplete: {
      type: String,
      default: "off"
    },
    validateEvent: {
      type: Boolean,
      default: true
    },
    batteryCapacity:Number
  },
  data() {
    return {
      checkForm: true,
      //tUnit: temUnit,
      temType: temUnit(),
      switchStatus: {
        warningOpenStatus: true,
        socSwitchStatus: true,
        tempSwitchStatus: true,
        volProtectSwitchStatus: false,
        voltageSwitchStatus: true,
        supportWaterLevelStatus: false,
        netSwitchStatus: true,
        chargeCurrentSwitchStatus: true,
        dischargeCurrentSwitchStatus: true,
        halfvChecked: false,
        linchongChecked:true,
        chargeDisChecked:true,
        cheliangChecked:false,
        dianchiChecked:false
      },
      form: {
        warningOpen: 1,

        socSwitch: 1,
        minSoc: 30,
        maxSoc: 80,

        tempSwitch: 1,
        minTemp: 0,
        maxTemp: 50,
        maxTemp2: 55,
        maxTemp3: 60,
        errTemp: 101,

        volProtectSwitch: 1,
        voltageSwitch: 1,
        voltageDuration: 15,
        recoveryVoltage: 30,
        minV: 75,
        lowVolLevel2: 60,
        lowVolLevel3: 55,
        maxV: 148,

        supportWaterLevel2: 0,
        supportWaterLevel: 1,
        waterDuration: 30,

        netSwitch: 1,
        offLine: 168,

        geofenceSwitch: 1,

        chargeCurrentSwitch: 1,
        chargeCurrent: 225,
        dischargeCurrentSwitch: 1,
        dischargeCurrent: 450,
        currentDuration: 15,

        supportHalfVol: 0,
        halfVol: 0,
        halfVoltageDuration: 90,

        status: 1,
        mcuId: this.$route.query.mcuId,
        batteryType: 2,
        updateById: 228,
        companyId: 34,
        updateTime: 1631671109213,
        intermediateChargeTimes:10,
        chargingDischargingRateValue: 200,
        vehicleMaintenanceDay:1,
        batteryMaintenanceType:1,
        batteryMaintenanceValue:1,
        dataServiceExpireSwitch: 0
      },
      owerPersonSelect: [], // 选中的当前设备拥有人--编辑
      owerPersonOptions: [], // 当前设备拥有人--编辑
      batterySystemVolt: 24,
      dianchiVal1: 1, // 电池维护 周期性维护每月几号
      dianchiVal2: 0, // 电池维护 每充容量,
      users:[],      
      statusSwitches: [1, 2, 3],

      selectUserId:[],
      selectUserName:[],//选中的推送人名称
    };
  },
  computed: {
    mcuId() {
      return this.$route.query.mcuId;
    },
    batteryMainOptions() { // 电池维护
      return [
        { value: 1, label: this.$t('warningSet.periodic_maint') },
        { value: 2, label: this.$t('warningSet.capacity_maint') }
      ]
    },
    subNewsOptions() { // 订阅消息
      return [
        { key: 1, label: 'warningSet.StartCharge' },
        { key: 2, label: 'warningSet.full' },
        { key: 3, label: 'warningSet.DisCharging' }
      ]
    }
  },
  mounted() {
    console.log(this.mcuId);
    this.initData();
    this._getCompanyUserName()
  },
  watch: {
    batteryCapacity(newVal,oldVal){
      // console.log('batteryCapacity',newVal,oldVal)
      if(!oldVal&&newVal)this.initData();
    }
  },
  methods: {   
    _getCompanyUserName () {//获取可推送人列表
      getGroupCompanyUserList().then(res=>{
        if (res.resultCode == 1001) {
          this.users = res.resultModel
          if(!this.users||!this.users.length)return
          selectByMcuId({ mcuId: this.mcuId }).then(res => {
            if (res.resultModel && res.resultModel.userNameList) {
              var receiveUsersName = res.resultModel.userNameList|| []
              this.selectUserName=receiveUsersName
              this.selectUserId = []
              this.users.forEach((v, i) => {
                if(!v.children)return
                v.children.forEach(c=>{
                  receiveUsersName.forEach(m => {
                    if (c.label == m) {
                      this.selectUserId.push([v.label,m])
                    }
                  })
                })
              })
            }
          })
        }
      })
    }, 
    changeSelectUser(arr){
      console.log('changeSelectUser',arr)
      this.selectUserName=[]
      arr.forEach(v=>{
        this.selectUserName.push(v[1])
      })
    },
    fn(val,num){
      if(val&&this.batterySystemVolt){
        return (this.batterySystemVolt * Number(val / 100)).toFixed(2)
      }else{
        return (Number(this.batterySystemVolt) * num).toFixed(2)
      }
    },
    initData() {
      getwarningSettingByMcuId({ mcuId: this.mcuId }).then(res => {
        console.log('设备警告配置：', res)
        for(var attr in this.form){
          if(res.resultModel[attr]==0||res.resultModel[attr])this.form[attr]=res.resultModel[attr]
        }
        var config=JSON.parse(JSON.stringify(res.resultModel))
        if (null != res.resultModel.batterySystemVolt) {
          this.batterySystemVolt = res.resultModel.batterySystemVolt;
        }
        this.form.maxV = this.fn(config.maxV,1.48)
        this.form.minV = this.fn(config.minV,0.9)
        this.form.lowVolLevel2 = this.fn(config.lowVolLevel2,0.86)
        this.form.lowVolLevel3 = this.fn(config.lowVolLevel3,0.79)
        this.form.recoveryVoltage = this.fn(config.recoveryVoltage,1)      
        console.log('config',config)
        console.log('this.form',this.form)
        //因为soc、温度等默认开启，所以返回null时，默认开启
        this.switchStatus.warningOpenStatus = this.form.warningOpen!=0? true: false;
        this.switchStatus.socSwitchStatus = this.form.socSwitch!=0? true: false;
        this.switchStatus.tempSwitchStatus = this.form.tempSwitch!=0? true: false;
        this.switchStatus.volProtectSwitchStatus = this.form.volProtectSwitch? true: false;
        this.switchStatus.voltageSwitchStatus = this.form.voltageSwitch!=0? true: false;
        this.switchStatus.supportWaterLevelStatus = this.form.supportWaterLevel? true: false;
        this.switchStatus.netSwitchStatus = this.form.netSwitch!=0? true: false;
        this.switchStatus.chargeCurrentSwitchStatus = this.form.chargeCurrentSwitch!=0? true: false;
        this.switchStatus.dischargeCurrentSwitchStatus = this.form.dischargeCurrentSwitch!=0? true: false;
        this.switchStatus.halfvChecked = config.halfVolSwitch? true: false;
        this.switchStatus.linchongChecked = config.fullChargeRequestSwitch!=0? true: false;
        this.switchStatus.chargeDisChecked = config.chargingDischargingRateSwitch!=0? true: false;
        this.switchStatus.cheliangChecked = config.vehicleMaintenanceSwitch? true: false;
        this.switchStatus.dianchiChecked = config.batteryMaintenanceSwitch? true: false;
        if (this.temType == "℉") {
          this.form.minTemp = temChange(this.form.minTemp);
          this.form.maxTemp = temChange(this.form.maxTemp);
          this.form.maxTemp2 = temChange(this.form.maxTemp2);
          this.form.maxTemp3 = temChange(this.form.maxTemp3);
          this.form.errTemp = temChange(this.form.errTemp);
        }
        if(this.batteryCapacity){
          this.form.chargeCurrent=!this.form.chargeCurrent?this.batteryCapacity:this.form.chargeCurrent
          this.form.dischargeCurrent=!this.form.dischargeCurrent?this.batteryCapacity*2:this.form.dischargeCurrent
        }
        this.form.currentDuration=!this.form.currentDuration?15:this.form.currentDuration
              // 电池维护
        if (this.form.batteryMaintenanceType == 2) {
          this.dianchiVal2 = this.form.batteryMaintenanceValue
        } else {
          this.dianchiVal1 = this.form.batteryMaintenanceValue ? this.form.batteryMaintenanceValue : 1
        }

        // 推送消息类型
        this.statusSwitches=[]
        getByMcuId(this.mcuId).then(res=>{
          this.statusSwitches=[]
          if(res.resultCode==1001&&res.resultModel){
            if(res.resultModel.startCharging== 1)this.statusSwitches.push(1)
            if(res.resultModel.fullCharge== 1)this.statusSwitches.push(2)
            if(res.resultModel.batteryUse== 1)this.statusSwitches.push(3)
          }
        })

      }),
      getCompanyUserName({ mcuId: this.mcuId }).then(res => {
        this.owerPersonOptions = res.resultModel;
      });
    },
    inputBlur(event, type) {
      //获取点击对象
      var el = event.currentTarget;
      if (el.value == "" || (type != "minTemp" && el.value < 0)) {
        $(el).css("border", "1px solid red");
      } else {
        $(el).css("border", "1px solid #DCDFE6");
      }
      this.checkForm =$("[style='border: 1px solid red;']").length > 0 ? false : true;
    },
    checkExist(num){
      var myNum=num
      if(typeof num=='string')myNum=num.length>0?Number(num):null
      if(myNum||myNum==0){
        return true
      }else{
        return false
      }
    },
    onSubmit() {
      console.log('提交',this.form)
      // return
      if (this.switchStatus.warningOpenStatus && !this.checkForm) {
        this.$message({
          type: "error",
          message: this.$t("warningSet.parameterError")
        });
        return;
      }
      //soc
      if (
        this.switchStatus.warningOpenStatus &&
        this.switchStatus.socSwitchStatus &&
        (!this.checkExist(this.form.minSoc) || !this.checkExist(this.form.maxSoc))
              ) {
        this.$message({
          type: "error",
          message:
            this.$t("warningSet.socWarn") + this.$t("warningSet.parameterError")
        });
        return;
      }
      //温度
      if (this.switchStatus.warningOpenStatus &&this.switchStatus.tempSwitchStatus &&        
          (!this.checkExist(this.form.minTemp) ||!this.checkExist(this.form.maxTemp) ||!this.checkExist(this.form.maxTemp2) ||!this.checkExist(this.form.maxTemp3) ||!this.checkExist(this.form.errTemp))
        ) {
        this.$message({
          type: "error",
          message:
            this.$t("warningSet.temWarn") + this.$t("warningSet.parameterError")
        });
        return;
      }
      //电压
      if (
        this.switchStatus.warningOpenStatus &&
        this.switchStatus.voltageSwitchStatus &&
        (this.form.minV == "" ||
          this.form.minV <= 0 ||
          this.form.lowVolLevel2 == "" ||
          this.form.lowVolLevel2 <= 0 ||
          this.form.lowVolLevel3 == "" ||
          this.form.lowVolLevel3 <= 0 ||
          this.form.recoveryVoltage == "" ||
          this.form.recoveryVoltage <= 0 ||
          this.form.maxV == "" ||
          this.form.maxV <= 0 ||
          this.form.voltageDuration == "" ||
          this.form.voltageDuration <= 0)
              ) {
        this.$message({
          type: "error",
          message:this.$t("warningSet.voltage") + this.$t("warningSet.parameterError")
        });
        return;
      }
      //低压保护
      if (
        this.switchStatus.warningOpenStatus &&
        this.switchStatus.volProtectSwitchStatus &&
        (this.form.minV == "" ||
          this.form.minV <= 0 ||
          this.form.recoveryVoltage == "" ||
          this.form.recoveryVoltage <= 0 ||
          this.form.voltageDuration == "" ||
          this.form.voltageDuration <= 0)
              ) {
        this.$message({
          type: "error",
          message:
            this.$t("warningSet.LowVoltageProtection") +
            this.$t("warningSet.parameterError")
        });
        return;
      }
      //半电压
      if (this.switchStatus.warningOpenStatus &&this.form.supportHalfVol == 1 &&(!this.checkExist(this.form.halfVol)||!this.checkExist(this.form.halfVoltageDuration))) {
        this.$message({
          type: "error",
          message:this.$t("warningSet.HalfV") + this.$t("warningSet.parameterError")
        });
        return;
      }
      //液位
      if (this.switchStatus.warningOpenStatus &&this.form.supportWaterLevel2 == 1 &&this.switchStatus.supportWaterLevelStatus &&(this.form.waterDuration == "" || this.form.waterDuration <= 0)) {
        this.$message({
          type: "error",
          message:this.$t("warningSet.LevelWarning") +this.$t("warningSet.parameterError")
        });
        return;
      }
      //离线
      if (this.switchStatus.warningOpenStatus &&this.switchStatus.netSwitchStatus &&(this.form.offLine == "" || this.form.offLine <= 0)) {
        this.$message({
          type: "error",
          message:this.$t("warningSet.OfflineTime") +this.$t("warningSet.parameterError")
        });
        return;
      }
      //电流
      if ((this.switchStatus.warningOpenStatus &&this.switchStatus.dischargeCurrentSwitchStatus &&(this.form.dischargeCurrent == "" ||this.form.currentDuration == "" ||this.form.currentDuration <= 0))
       ||(this.switchStatus.chargeCurrentSwitchStatus &&(this.form.chargeCurrent == "" ||this.form.currentDuration == "" ||this.form.currentDuration <= 0))) {
        this.$message({
          type: "error",
          message:
            this.$t("warningSet.current") + this.$t("warningSet.parameterError")
        });
        return;
      }

      this.form.warningOpen = this.switchStatus.warningOpenStatus ? 1 : 0;
      this.form.socSwitch = this.switchStatus.socSwitchStatus ? 1 : 0;
      this.form.tempSwitch = this.switchStatus.tempSwitchStatus ? 1 : 0;
      this.form.volProtectSwitch = this.switchStatus.volProtectSwitchStatus? 1: 0;
      this.form.voltageSwitch = this.switchStatus.voltageSwitchStatus ? 1 : 0;
      this.form.supportWaterLevel = this.switchStatus.supportWaterLevelStatus? 1: 0;
      this.form.netSwitch = this.switchStatus.netSwitchStatus ? 1 : 0;
      this.form.chargeCurrentSwitch = this.switchStatus.chargeCurrentSwitchStatus? 1: 0;
      this.form.dischargeCurrentSwitch = this.switchStatus.dischargeCurrentSwitchStatus? 1: 0;
      this.form.halfVolSwitch = this.switchStatus.halfvChecked ? 1: 0;
      this.form.fullChargeRequestSwitch = this.switchStatus.linchongChecked ? 1: 0;
      this.form.chargingDischargingRateSwitch = this.switchStatus.chargeDisChecked ? 1: 0;
      this.form.vehicleMaintenanceSwitch = this.switchStatus.cheliangChecked ? 1: 0;
      this.form.batteryMaintenanceSwitch = this.switchStatus.dianchiChecked ? 1: 0;

      if (this.temType == "℉") {
        this.form.minTemp = temHsdToSsd(this.form.minTemp);
        this.form.maxTemp = temHsdToSsd(this.form.maxTemp);
        this.form.maxTemp2 = temHsdToSsd(this.form.maxTemp2);
        this.form.maxTemp3 = temHsdToSsd(this.form.maxTemp3);
        this.form.errTemp = temHsdToSsd(this.form.errTemp);
      }
      this.form.status = 1;
      if (this.form.batteryMaintenanceType == 2) {
        this.form.batteryMaintenanceValue = this.dianchiVal2
      } else {
        this.form.batteryMaintenanceValue = this.dianchiVal1
      }

      var submitForm = JSON.parse(JSON.stringify(this.form));

      submitForm.minV = ((submitForm.minV / this.batterySystemVolt) *100).toFixed(2);
      submitForm.lowVolLevel2 = ((submitForm.lowVolLevel2 / this.batterySystemVolt) *100).toFixed(2);
      submitForm.lowVolLevel3 = ((submitForm.lowVolLevel3 / this.batterySystemVolt) *100).toFixed(2);
      submitForm.maxV = ((submitForm.maxV / this.batterySystemVolt) *100).toFixed(2);
      submitForm.recoveryVoltage = ((submitForm.recoveryVoltage / this.batterySystemVolt) *100).toFixed(2);

      this.$confirm(this.$t("basicinfo.submitChange"), "", {
        // '是否提交修改？'
        confirmButtonText: this.$t("button.Confirm"), // '确定',
        cancelButtonText: this.$t("button.Cancel"),
        type: "warning"
      }).then(() => {
        var msgUserParam={
          mcuId: this.$route.query.mcuId,
          //updateById: this.$store.state.companyId,
          updateById: this.$store.state.userInfo.id,
          userNameList: this.selectUserName
        }
        updatePushMsgUser(msgUserParam).then(res => {
          // 提交推送人
        });
        // param.warningOpen = 1
        updateWarningSetting(submitForm).then(res => {
          // 提交配置
          if (res.resultCode == 1001) {
            this.$message({
              type: "success",
              message: this.$t("warningSet.submitted")
            });
            //this.isShowEditTable = false
            //this.queryWarnSet()
          }
        });
        var param={
          "batteryUse": this.statusSwitches.indexOf(3)>-1?1:0,
          "fullCharge": this.statusSwitches.indexOf(2)>-1?1:0,
          "id": 0,
          "mcuId":this.$route.query.mcuId,
          "startCharging":this.statusSwitches.indexOf(1)>-1?1:0
        }
        console.log('param',param)
        saveOrUpdate(param).then(res=>{})
        var warnParam={
          pushMsgUser:msgUserParam,
          usageSetting:param,
          warningSettings:submitForm,
        }
        insertYhubWarningSettingLog(warnParam).then(res=>{})
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.el-form-item {
  border-bottom: 1px dashed #dfe6ec;
}

.in_item {
  margin-right: 20px;
  margin-bottom: 10px;
  margin-left: 120px;
}

.errorValue {
  border: 1px solid red;
}
</style> 